import { ORDER_TEMPLATE } from '@/utils';

export const REFUND_ERROR_MESSAGE = {
  alreadyCanceled: '취소 요청한 주문 상품 중에 이미 취소된 상품이 있습니다.',
  notAvailable: '환불 가능한 주문이 아닙니다.',
  notEnough: '환불할 금액이 없습니다.',
};

export const REFUND_ERROR_TEMPLATE = (message: keyof typeof REFUND_ERROR_MESSAGE) => {
  if (
    message === REFUND_ERROR_MESSAGE.alreadyCanceled ||
    message === REFUND_ERROR_MESSAGE.notAvailable
  ) {
    return ORDER_TEMPLATE.refund.alreadyCanceled();
  }
  return ORDER_TEMPLATE.refund.notEnough();
};
